import request from '@/utils/request'
import URL from './urlTranslator'

export function getBankAccountList(officeUuid) {
  return request({
    url: URL.sys.bankAccount,
    method: 'get',
    params: { officeUuid }
  })
}

export function saveBankAccount(data) {
  return request({
    url: URL.sys.bankAccount,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function saveOfficeBankAccount(data) {
  return request({
    url: URL.sys.saveOfficeBankAccountUrl,
    method: 'post',
    data
  })
}

export function saveTaxControlPanel(data) {
  return request({
    url: URL.sys.saveTaxControlPanelUrl,
    method: 'post',
    data
  })
}

export function batchDelBankAccount(uuids) {
  return request({
    url: URL.sys.bankAccount,
    method: 'delete',
    data: [...uuids]
  })
}
